import { CallToAction } from "shared/types/assetExporter";

export const isCallToActionValue = (value: string) => {
  return Object.values(CallToAction).some(
    cta =>
      cta.replace(/\s+/g, "_").toLowerCase() ===
      value.trim().replace(/\s+/g, "_").toLowerCase(),
  );
};
